/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import {
  Button,
  Modal,
  ModalContent,
  ModalDescription,
  ModalHeader,
  Text,
  Conditional,
  Cross,
} from '@cashfree-intl/coherent';

import './styles.scss';
import PropTypes from 'prop-types';
import { capitalizeEveryWord } from 'utils/common';
import CustomIcon from '../CustomIcons';

const TncModal = ({
  open,
  title,
  showWillDoLater,
  handleOnDoLater,
  handleOnAgree,
  iframeUrl,
  tncUrl,
  closeModal,
  buttonText,
  htmlContent,
  disableCross,
}) => (
  <Modal open={open} className="tnc-modal">
    <ModalHeader>
      {title}{' '}
      <Conditional if={!!tncUrl}>
        <a
          target="_blank"
          className="tnc-link"
          href={tncUrl}
          data-event-name="Link_Open_Link_In_A_New_Tab"
        >
          <CustomIcon componentName="OPEN_LINK" fill="var(--PRIMARY)" />
          <Text color="primary">Open link in a new tab</Text>{' '}
        </a>
      </Conditional>
      <Conditional if={htmlContent && !disableCross}>
        <div
          className="close-modal"
          onClick={() => closeModal()}
          data-event-name="Form_Terms_And_Conditions_Icon_Close"
          data-ignore-inner-text="true"
        >
          <Cross size="md" />
        </div>
      </Conditional>
    </ModalHeader>
    <ModalContent>
      <ModalDescription className="tnc-desc">
        <iframe
          title="description"
          src={iframeUrl}
          srcDoc={htmlContent || undefined}
          frameBorder="0"
          width="100%"
          height="100%"
          allowFullScreen
        />
      </ModalDescription>
    </ModalContent>
    <Modal.Actions>
      {showWillDoLater && (
        <Button
          link
          onClick={handleOnDoLater}
          data-event-name="Button_Terms_And_Conditions_Ill_Do_This_Later"
        >
          I’ll do this later
        </Button>
      )}
      <Button
        primary
        onClick={handleOnAgree}
        data-event-name={`Primary_Button_Terms_And_Conditions_${capitalizeEveryWord(
          buttonText,
        )}`}
      >
        {buttonText}
      </Button>
    </Modal.Actions>
  </Modal>
);

TncModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  showWillDoLater: PropTypes.bool,
  handleOnDoLater: PropTypes.func,
  handleOnAgree: PropTypes.func,
  iframeUrl: PropTypes.string,
  tncUrl: PropTypes.string,
  closeModal: PropTypes.func,
  buttonText: PropTypes.string,
  htmlContent: PropTypes.string,
  disableCross: PropTypes.bool,
};

TncModal.defaultProps = {
  open: false,
  title: 'Terms and Conditions',
  showWillDoLater: false,
  handleOnDoLater: () => {},
  handleOnAgree: () => {},
  iframeUrl: '',
  tncUrl: '',
  buttonText: 'I agree',
  htmlContent: '',
};

export default TncModal;
